module.exports = "/dog-racing/img/header-babaijebu.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/dog-racing/img/header-babaijebu.png
// module id = 268
// module chunks = 7